import React, { useState } from 'react';
import ApiService from '../services/apiService';
import './TonModal.css';
import './ButtonStyles.css';

const TonModal = ({ isOpen, onClose, onTopUp, userId }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('ton_wallet');

  if (!isOpen) {
    return null;
  }

  const handleTopUp = async () => {
    const numericAmount = parseFloat(amount);
    if (!isNaN(numericAmount) && numericAmount > 0) {
      setLoading(true);
      setError('');

      try {
        // Создаем платеж
        const paymentResult = await ApiService.createPayment(
          userId || 'default_user',
          numericAmount,
          'ton',
          paymentMethod
        );

        if (paymentResult.success) {
          // Если это ручное пополнение, сразу подтверждаем
          if (paymentMethod === 'manual') {
            await ApiService.confirmPayment(paymentResult.payment.transactionId);
          }

          // Обновляем баланс в родительском компоненте
          onTopUp(numericAmount);
          onClose();
        } else {
          setError('Ошибка создания платежа');
        }
      } catch (error) {
        console.error('Payment error:', error);
        setError(error.message || 'Произошла ошибка при пополнении');
      } finally {
        setLoading(false);
      }
    } else {
      setError('Введите корректную сумму');
    }
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
  };

  const quickAmounts = [0.1, 0.5, 1, 2, 5, 10];

  return (
    <div className="ton-modal-overlay" onClick={onClose}>
      <div className="ton-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="ton-modal-close-btn" onClick={onClose}>&times;</button>
        <h2 className="ton-modal-title">Пополнить TON</h2>
        
        {error && (
          <div className="ton-modal-error">
            {error}
          </div>
        )}

        <div className="ton-modal-method-selector">
          <label className="ton-modal-method-label">
            <input
              type="radio"
              name="paymentMethod"
              value="ton_wallet"
              checked={paymentMethod === 'ton_wallet'}
              onChange={() => handlePaymentMethodChange('ton_wallet')}
            />
            TON Wallet
          </label>
          <label className="ton-modal-method-label">
            <input
              type="radio"
              name="paymentMethod"
              value="telegram"
              checked={paymentMethod === 'telegram'}
              onChange={() => handlePaymentMethodChange('telegram')}
            />
            Telegram Bot
          </label>
          <label className="ton-modal-method-label">
            <input
              type="radio"
              name="paymentMethod"
              value="manual"
              checked={paymentMethod === 'manual'}
              onChange={() => handlePaymentMethodChange('manual')}
            />
            Ручное пополнение
          </label>
        </div>

        <div className="ton-modal-quick-amounts">
          {quickAmounts.map(quickAmount => (
            <button
              key={quickAmount}
              className="quick-amount-button quick-amount-button-cyan"
              onClick={() => setAmount(quickAmount.toString())}
            >
              {quickAmount} TON
            </button>
          ))}
        </div>

        <input 
          type="number"
          className="ton-modal-input"
          placeholder="Введите количество TON"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          autoFocus
          min="0.01"
          step="0.01"
        />
        
        <button 
          className="neon-button neon-button-cyan"
          onClick={handleTopUp}
          disabled={loading}
        >
          {loading ? 'Обработка...' : 'Пополнить'}
        </button>

        {paymentMethod === 'ton_wallet' && (
          <div className="ton-modal-info">
            После нажатия "Пополнить" откроется ваш TON кошелек для перевода
          </div>
        )}
        
        {paymentMethod === 'telegram' && (
          <div className="ton-modal-info">
            После нажатия "Пополнить" вы будете перенаправлены в Telegram для оплаты
          </div>
        )}
      </div>
    </div>
  );
};

export default TonModal; 